import { MenuItem, Select, TextField } from "@mui/material";
import { Field } from "formik";
import { CustomErrorMessage } from "../../../components/FormComponents/CustomErrorMessage";
import { FormFieldWrapper } from "../../../components/FormComponents/FieldWrapper";
import { hasError } from "../../../components/FormComponents/utils";
import { IPeca } from "../../Obras/newObra/IObra";
import DeleteIcon from '@mui/icons-material/Delete';
import CustomButtonSimple from "../../../components/CustomMiscellaneous/CustomButtonSimple";
import AddIcon from '@mui/icons-material/Add';





export function PecasParaEntregaForm({ formikProps, arrayHelpers, pecas }: { formikProps: any, arrayHelpers: any, pecas: IPeca[] }) {

    const { values, errors, touched, handleChange } = formikProps;

    return (<div className="mt-5">
        <h2 className="font-bold mb-4 mt-3">Peças para entrega</h2>
        <div className="flex font-bold mb-2">
            <h2 className="w-1/2 pl-3">Peças</h2>
            <h2 className="w-1/2">Quantidades</h2>
        </div>
        {values?.pecasParaEntrega && values.pecasParaEntrega.length > 0 ? (values.pecasParaEntrega.map((p: IPeca, idx: number) =>
            <div key={idx} className="flex items-center">
                    <Field
                        className="w-full mx-2"
                        name={`pecasParaEntrega.${idx}.peca`}
                        
                        as={Select}
                        margin={"dense"}
                        variant={'outlined'}
                        label={'Peça'}
                        renderValue={(item: IPeca) => item.reference}
                    >
                        {pecas.map((c: IPeca) => <MenuItem key={c.id} value={c as any}>{c.reference}</MenuItem>)}
                    </Field>

                    <>
                        <Field
                            className="w-full mx-2"
                            name={`pecasParaEntrega.${idx}.quantidade`}
                            as={TextField}
                            error={hasError({ errors, touched, name: 'quantidade' })}
                            variant={'outlined'}
                            type={'number'}
                            label={'Quantidade'} />
                        <CustomErrorMessage name={"quantidade"} />
                    </>

                <DeleteIcon className="text-red-400 cursor-pointer ml-2" onClick={() => arrayHelpers.remove(idx)} />


            </div>
        )) : null}

        <CustomButtonSimple className="mt-4 h-8" text="Adicionar peça para entrega" Icon={()=> <AddIcon/>} onClick={()=> arrayHelpers.push({peca: null, quantidade: 0})} />

    </div>)



}